import {Component, computed, inject, model} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {SharedModule} from '../../../../core/modules/shared.module';
import {MaterialModule} from '../../../../core/modules/material.module';

@Component({
  selector: 'edit-competency-modal',
  templateUrl: './edit-competency.modal.html',
  styleUrls: ['./edit-competency.modal.scss'],
  imports: [
    SharedModule,
    MaterialModule
  ]
})

export class EditCompetencyModalComponent {
  readonly dialogRef = inject(MatDialogRef<EditCompetencyModalComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly title = model(this.data.title);
  readonly color = model(this.data.color);
  header = this.data.header;

  isTitleEmpty = computed(() => this.title().trim().length === 0);

  onSaveClick() {
    if (this.color()) {
      this.dialogRef.close({title: this.title(), color: this.color()});
    } else {
      this.dialogRef.close(this.title());
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSettingsChange(ev) {
    if (ev?.bg) {
      this.color.set(ev.bg);
    }
  }
}
